import { render } from "./OilData.vue?vue&type=template&id=1db1ee52"
import script from "./OilData.vue?vue&type=script&lang=js"
export * from "./OilData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__